import { createSlice, PayloadAction, SliceCaseReducers, SliceSelectors } from '@reduxjs/toolkit';
import { FollowUpStatus, TicketStatus } from 'services/order/order.type';
import { RootState } from '../store';

export const ordersStatusSliceName = 'ordersStatus';

export type ProductsStatuses = Record<string, TicketStatus>;

type OrderStatusInformation = {
    status: FollowUpStatus;
    restaurantId: string;
    orderId: string;
    products?: Record<string, TicketStatus>;
};
export type OrdersStatusState = Record<string, OrderStatusInformation> | null;

const initialState: OrdersStatusState = null;

export const ordersStatusSlice = createSlice<
    OrdersStatusState,
    SliceCaseReducers<OrdersStatusState>,
    string,
    SliceSelectors<OrdersStatusState>
>({
    name: ordersStatusSliceName,
    initialState,
    reducers: {
        updateOrdersStatus: (state, action: PayloadAction<OrdersStatusState>) => ({
            ...state,
            ...action.payload,
        }),
        resetStatuses: (_state, _action: PayloadAction) => {
            return null;
        },
    },
});

export const getStatuses = (state: RootState): OrdersStatusState => state.ordersStatus;
export const getFollowUpOrdersId = (state: RootState): string[] | null => {
    const stateCopy = getStatuses(state);
    if (!stateCopy) return null;
    return Object.keys(stateCopy);
};
export const getProductsStatuses =
    (orderId: string) =>
    (state: RootState): Record<string, TicketStatus> | null => {
        const stateCopy = getStatuses(state);
        if (!stateCopy) return null;
        return stateCopy[orderId]?.products ?? null;
    };

export const { updateOrdersStatus, resetStatuses } = ordersStatusSlice.actions;
